import api from './api';

const taskService = {
  // ============ BOARDS ============
  
  createBoard: async (boardData) => {
    try {
      const response = await api.post('/tasks/boards', boardData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar board:', error);
      throw error;
    }
  },

  getBoards: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.include_archived) params.append('include_archived', filters.include_archived);
      if (filters.project_id) params.append('project_id', filters.project_id);
      
      const response = await api.get(`/tasks/boards?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar boards:', error);
      throw error;
    }
  },

  getBoardById: async (boardId) => {
    try {
      const response = await api.get(`/tasks/boards/${boardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar board:', error);
      throw error;
    }
  },

  updateBoard: async (boardId, boardData) => {
    try {
      const response = await api.put(`/tasks/boards/${boardId}`, boardData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar board:', error);
      throw error;
    }
  },

  deleteBoard: async (boardId) => {
    try {
      const response = await api.delete(`/tasks/boards/${boardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar board:', error);
      throw error;
    }
  },

  archiveBoard: async (boardId) => {
    try {
      const response = await api.post(`/tasks/boards/${boardId}/archive`);
      return response.data;
    } catch (error) {
      console.error('Erro ao arquivar board:', error);
      throw error;
    }
  },

  restoreBoard: async (boardId) => {
    try {
      const response = await api.post(`/tasks/boards/${boardId}/restore`);
      return response.data;
    } catch (error) {
      console.error('Erro ao restaurar board:', error);
      throw error;
    }
  },

  // ============ COLUNAS ============
  
  createColumn: async (columnData) => {
    try {
      const response = await api.post('/tasks/columns', columnData);
      return response.data.column || response.data;
    } catch (error) {
      console.error('Erro ao criar coluna:', error);
      throw error;
    }
  },

  getBoardColumns: async (boardId) => {
    try {
      const response = await api.get(`/tasks/boards/${boardId}/columns`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar colunas:', error);
      throw error;
    }
  },

  updateColumn: async (columnId, columnData) => {
    try {
      const response = await api.put(`/tasks/columns/${columnId}`, columnData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar coluna:', error);
      throw error;
    }
  },

  reorderColumns: async (columnOrders) => {
    try {
      const response = await api.post('/tasks/columns/reorder', columnOrders);
      return response.data;
    } catch (error) {
      console.error('Erro ao reordenar colunas:', error);
      throw error;
    }
  },

  deleteColumn: async (columnId) => {
    try {
      const response = await api.delete(`/tasks/columns/${columnId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar coluna:', error);
      throw error;
    }
  },

  // ============ CARDS (TAREFAS) ============
  
  createCard: async (cardData) => {
    try {
      const response = await api.post('/tasks/cards', cardData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar card:', error);
      throw error;
    }
  },

  getBoardCards: async (boardId, filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.column_id) params.append('column_id', filters.column_id);
      if (filters.assigned_to) params.append('assigned_to', filters.assigned_to);
      if (filters.priority) params.append('priority', filters.priority);
      if (filters.is_completed !== undefined) params.append('is_completed', filters.is_completed);
      if (filters.has_due_date) params.append('has_due_date', filters.has_due_date);
      if (filters.search) params.append('search', filters.search);
      
      const response = await api.get(`/tasks/boards/${boardId}/cards?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar cards:', error);
      throw error;
    }
  },

  getCardById: async (cardId) => {
    try {
      const response = await api.get(`/tasks/cards/${cardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar card:', error);
      throw error;
    }
  },

  updateCard: async (cardId, cardData) => {
    try {
      const response = await api.put(`/tasks/cards/${cardId}`, cardData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar card:', error);
      throw error;
    }
  },

  moveCard: async (cardId, columnId, order) => {
    try {
      const response = await api.post(`/tasks/cards/${cardId}/move`, {
        column_id: columnId,
        order: order
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao mover card:', error);
      throw error;
    }
  },

  deleteCard: async (cardId) => {
    try {
      const response = await api.delete(`/tasks/cards/${cardId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar card:', error);
      throw error;
    }
  },

  // ============ CHECKLISTS ============
  
  createChecklist: async (checklistData) => {
    try {
      const response = await api.post('/tasks/checklists', checklistData);
      return response.data.checklist || response.data;
    } catch (error) {
      console.error('Erro ao criar checklist:', error);
      throw error;
    }
  },

  updateChecklist: async (checklistId, checklistData) => {
    try {
      const response = await api.put(`/tasks/checklists/${checklistId}`, checklistData);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar checklist:', error);
      throw error;
    }
  },

  deleteChecklist: async (checklistId) => {
    try {
      const response = await api.delete(`/tasks/checklists/${checklistId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar checklist:', error);
      throw error;
    }
  },

  // ============ COMENTÁRIOS ============
  
  createComment: async (commentData) => {
    try {
      const response = await api.post('/tasks/comments', commentData);
      return response.data.comment || response.data;
    } catch (error) {
      console.error('Erro ao criar comentário:', error);
      throw error;
    }
  },

  updateComment: async (commentId, content) => {
    try {
      const response = await api.put(`/tasks/comments/${commentId}`, { content });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar comentário:', error);
      throw error;
    }
  },

  deleteComment: async (commentId) => {
    try {
      const response = await api.delete(`/tasks/comments/${commentId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar comentário:', error);
      throw error;
    }
  },

  // ============ ANEXOS ============
  
  uploadAttachment: async (cardId, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post(`/tasks/cards/${cardId}/attachments/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data.attachment || response.data;
    } catch (error) {
      console.error('Erro ao fazer upload:', error);
      throw error;
    }
  },

  addLinkAttachment: async (cardId, fileName, fileUrl) => {
    try {
      const params = new URLSearchParams();
      params.append('file_name', fileName);
      params.append('file_url', fileUrl);

      const response = await api.post(`/tasks/cards/${cardId}/attachments/link?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar link:', error);
      throw error;
    }
  },

  downloadAttachment: async (attachmentId, fileName) => {
    try {
      const response = await api.get(`/tasks/attachments/${attachmentId}/download`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName || 'arquivo');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      return { success: true };
    } catch (error) {
      console.error('Erro ao fazer download:', error);
      throw error;
    }
  },

  deleteAttachment: async (attachmentId) => {
    try {
      const response = await api.delete(`/tasks/attachments/${attachmentId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar anexo:', error);
      throw error;
    }
  },

  // ============ CARD ACTIONS ============
  
  copyCard: async (cardId, targetColumnId = null) => {
    try {
      const params = targetColumnId ? `?target_column_id=${targetColumnId}` : '';
      const response = await api.post(`/tasks/cards/${cardId}/copy${params}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao copiar card:', error);
      throw error;
    }
  },

  moveCardToBoard: async (cardId, targetBoardId, targetColumnId) => {
    try {
      const response = await api.post(`/tasks/cards/${cardId}/move-to-board`, null, {
        params: {
          target_board_id: targetBoardId,
          target_column_id: targetColumnId
        }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao mover card para outro board:', error);
      throw error;
    }
  },

  // ============ LABELS ============
  
  createLabel: async (labelData) => {
    try {
      const response = await api.post('/tasks/labels', labelData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar label:', error);
      throw error;
    }
  },

  getBoardLabels: async (boardId) => {
    try {
      const response = await api.get(`/tasks/boards/${boardId}/labels`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar labels:', error);
      throw error;
    }
  },

  deleteLabel: async (labelId) => {
    try {
      const response = await api.delete(`/tasks/labels/${labelId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar label:', error);
      throw error;
    }
  },

  addCardLabel: async (cardId, labelId) => {
    try {
      const response = await api.post(`/tasks/cards/${cardId}/labels/${labelId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar label ao card:', error);
      throw error;
    }
  },

  removeCardLabel: async (cardId, labelId) => {
    try {
      const response = await api.delete(`/tasks/cards/${cardId}/labels/${labelId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover label do card:', error);
      throw error;
    }
  },

  // ============ ATIVIDADES ============
  
  getCardActivities: async (cardId, limit = 50) => {
    try {
      const response = await api.get(`/tasks/cards/${cardId}/activities?limit=${limit}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao listar atividades:', error);
      throw error;
    }
  },

  // ============ DASHBOARD ============
  
  getDashboardStats: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      
      if (filters.board_id) params.append('board_id', filters.board_id);
      if (filters.start_date) params.append('start_date', filters.start_date);
      if (filters.end_date) params.append('end_date', filters.end_date);
      
      const response = await api.get(`/tasks/dashboard/stats?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas:', error);
      throw error;
    }
  },

  getMyTasks: async () => {
    try {
      const response = await api.get('/tasks/dashboard/my-tasks');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar minhas tarefas:', error);
      throw error;
    }
  },

  getOverdueTasks: async () => {
    try {
      const response = await api.get('/tasks/dashboard/overdue');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar tarefas vencidas:', error);
      throw error;
    }
  },

  // ============ LABELS ============
  
  getBoardLabels: async (boardId) => {
    try {
      const response = await api.get(`/tasks/boards/${boardId}/labels`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar labels:', error);
      throw error;
    }
  },

  createLabel: async (labelData) => {
    try {
      const response = await api.post('/tasks/labels', labelData);
      return response.data.label || response.data;
    } catch (error) {
      console.error('Erro ao criar label:', error);
      throw error;
    }
  },

  deleteLabel: async (labelId) => {
    try {
      const response = await api.delete(`/tasks/labels/${labelId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar label:', error);
      throw error;
    }
  },

  // ============ INTEGRAÇÕES ============
  
  getProjectCards: async (projectId) => {
    try {
      const response = await api.get(`/tasks/integrations/project/${projectId}/cards`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar cards do projeto:', error);
      throw error;
    }
  },

  getTicketCards: async (ticketId) => {
    try {
      const response = await api.get(`/tasks/integrations/ticket/${ticketId}/cards`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar cards do chamado:', error);
      throw error;
    }
  },

  getLeadCards: async (leadId) => {
    try {
      const response = await api.get(`/tasks/integrations/lead/${leadId}/cards`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar cards do lead:', error);
      throw error;
    }
  },

  // ============ HELPERS ============
  
  translatePriority: (priority) => {
    const translations = {
      'baixa': 'Baixa',
      'media': 'Média',
      'alta': 'Alta',
      'urgente': 'Urgente'
    };
    return translations[priority] || priority;
  },

  translateVisibility: (visibility) => {
    const translations = {
      'privado': 'Privado',
      'compartilhado': 'Compartilhado',
      'equipe': 'Equipe'
    };
    return translations[visibility] || visibility;
  },

  getPriorityColor: (priority) => {
    const colors = {
      'baixa': 'bg-gray-100 text-gray-800',
      'media': 'bg-blue-100 text-blue-800',
      'alta': 'bg-orange-100 text-orange-800',
      'urgente': 'bg-red-100 text-red-800'
    };
    return colors[priority] || 'bg-gray-100 text-gray-800';
  },

  getPriorityIcon: (priority) => {
    const icons = {
      'baixa': '↓',
      'media': '→',
      'alta': '↑',
      'urgente': '⚠'
    };
    return icons[priority] || '→';
  },

  isOverdue: (dueDate, isCompleted) => {
    if (!dueDate || isCompleted) return false;
    return new Date(dueDate) < new Date();
  },

  daysUntilDue: (dueDate) => {
    if (!dueDate) return null;
    
    const now = new Date();
    const due = new Date(dueDate);
    const diffTime = due - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    return diffDays;
  },

  formatDueDate: (dueDate) => {
    if (!dueDate) return null;
    
    const date = new Date(dueDate);
    const now = new Date();
    const diffDays = taskService.daysUntilDue(dueDate);
    
    if (diffDays === 0) return 'Hoje';
    if (diffDays === 1) return 'Amanhã';
    if (diffDays === -1) return 'Ontem';
    if (diffDays < 0) return `${Math.abs(diffDays)} dias atrás`;
    if (diffDays <= 7) return `Em ${diffDays} dias`;
    
    return date.toLocaleDateString('pt-BR');
  },

  calculateChecklistProgress: (checklists) => {
    if (!checklists || checklists.length === 0) {
      return { total: 0, completed: 0, percentage: 0 };
    }
    
    const total = checklists.length;
    const completed = checklists.filter(item => item.is_completed).length;
    const percentage = Math.round((completed / total) * 100);
    
    return { total, completed, percentage };
  },

  validateFile: (file) => {
    const maxSize = 10 * 1024 * 1024; // 10 MB
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/plain',
      'image/png',
      'image/jpeg',
      'image/jpg'
    ];

    if (file.size > maxSize) {
      return { valid: false, error: 'Arquivo muito grande. Máximo: 10 MB' };
    }

    if (!allowedTypes.includes(file.type)) {
      return { 
        valid: false, 
        error: 'Tipo de arquivo não permitido. Use PDF, DOC, DOCX, XLS, XLSX, TXT, PNG ou JPG' 
      };
    }

    return { valid: true };
  },

  formatFileSize: (bytes) => {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  },

  getAvailableColors: () => {
    return [
      { name: 'Azul', value: '#3b82f6' },
      { name: 'Verde', value: '#22c55e' },
      { name: 'Vermelho', value: '#ef4444' },
      { name: 'Amarelo', value: '#eab308' },
      { name: 'Roxo', value: '#a855f7' },
      { name: 'Rosa', value: '#ec4899' },
      { name: 'Laranja', value: '#f97316' },
      { name: 'Cinza', value: '#6b7280' },
      { name: 'Índigo', value: '#6366f1' },
      { name: 'Ciano', value: '#06b6d4' }
    ];
  },

  // Get all cards (for calendar view)
  getAllCards: async () => {
    try {
      const response = await api.get('/tasks/cards/all');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar todos os cards:', error);
      throw error;
    }
  },

  translatePriority: (priority) => {
    const translations = {
      baixa: 'Baixa',
      media: 'Média',
      alta: 'Alta',
      urgente: 'Urgente'
    };
    return translations[priority] || priority;
  }
};

export default taskService;
